'use client';

import { useEffect, useState } from 'react';

import dynamic from 'next/dynamic';
import { useExitIntent } from 'use-exit-intent';

import { PopupDetail } from '@/types/Popup';

const Popup = dynamic(() => import('./Popup'));

export default function BeforeClosePopup({ popup }: { popup: PopupDetail }) {
  const [isVisible, setIsVisible] = useState(false);
  const [hasImageLoaded, setHasImageLoaded] = useState(false);
  const { registerHandler, resetState } = useExitIntent({
    cookie: {
      daysToExpire: 30,
      key: 'use-exit-intent',
    },
    desktop: {
      triggerOnIdle: false,
      useBeforeUnload: false,
      triggerOnMouseLeave: true,
      delayInSecondsToTrigger: 1,
    },
    mobile: {
      triggerOnIdle: true,
      delayInSecondsToTrigger: 1,
    },
  });

  registerHandler({
    id: 'openModal',
    handler: () => {
      console.log('user trying to exit');
      resetState();
      if (typeof popup?.Name !== 'string') return;

      const exitInit = Number(sessionStorage.getItem('exit_init'));
      if (exitInit != 1) {
        setIsVisible(true);
      }
    },
    context: ['onDesktop', 'onMobile'],
  });

  useEffect(() => {
    if (isVisible && hasImageLoaded) sessionStorage.setItem('exit_init', '1');
  }, [hasImageLoaded, isVisible]);

  console.log('user loaded popup');

  const closePopup = () => {
    setIsVisible(false);
  };

  return (
    <Popup
      popup={popup}
      isOpen={isVisible}
      onClose={closePopup}
      onImageLoaded={() => {
        console.log('modal is image loaded');
        setHasImageLoaded(true);
      }}
    />
  );
}
